;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.LeaguesRegenerationList = Marionette.ItemView.extend({
		template: JST.LeaguesRegenerationList,
		ui: {
			show: '.js-show'
		},
		initialize: function() {

			this.rounds            = this.getOption('rounds');
			this.leagues            = this.getOption('leagues');

			var complete = [
				this.rounds.fetch({ cache: true, expires: 60 }),
				this.leagues.show_for_regenerate().fetch()
			];

			$.when.apply(null, complete).done(_.bind(this.initTemplate, this));
		},

		initTemplate: function() {

			if (this.isNotEmptyLeagues()) {
				this.setModelData().render();
			}
			return this;
		},

		isNotEmptyLeagues: function() {

			if (!this.leagues.length) {
				this.trigger('leagues_list:empty');

				return false;
			}

			return true;
		},
		setModelData: function() {

			this.model.set({
				leagues:     this.leagues.toJSON(),
				rounds:      this.rounds.toJSON()
			});

			return this;
		}

	});

}(window, APP, Backbone, Marionette, $, _));